import { atom } from 'recoil';
import BeaconFilterItemRequest from '../models/BeaconFilterItemRequest';

const stateFilterMeasure = atom({
  key: 'filter.measure',
  default: null as BeaconFilterItemRequest | null,
});

export default stateFilterMeasure;
